module.exports = __webpack_public_path__ + "img/BizOpslogo_Updated.b08c9be2.svg";